import { render } from "./ClientCallSquadListBlock.vue?vue&type=template&id=6a4fe91e"
import script from "./ClientCallSquadListBlock.vue?vue&type=script&lang=js"
export * from "./ClientCallSquadListBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__